// extracted by mini-css-extract-plugin
export var quillEditor = "_or-1";
export var variable = "_or-0";